export enum SettingsTab {
  TUTORIALS,
  DISPLAY_SETTINGS,
  NOTIFICATIONS,
  CONTACT,
}
